import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import toast from "react-hot-toast";
import moment from 'moment'
import { Box } from '@mui/material'

import AddSuperUserAutocomplete from '../../../common/CustomInput/addSuperUserAutocomplete'
import CustomActionButton from '../../../common/CustomActionButton';
import CustomInputV2 from '../../../common/CustomInputV2';

import { ActivateTherapist } from '../../../redux/user/actions';
import { apiCallV2 } from '../../../utils/api'
import { delay } from '../../../utils';
import { genders } from '../../../constants';
import { getAge } from '../../../utils/date';

let timer = null
const AddUserUser = (props) => {
    const { setShowModal, reload } = props;
    // autocomplete states
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const loading = open && options.length === 0;
    const [selected, setSelected] = useState('')
    const [email, setEmail] = useState('');

    // fetch all users to select for super user
    const handleOptions = async (value) => {
        setOptions([])
        clearTimeout(timer)
        timer = setTimeout(async () => {

            const res = await apiCallV2(
                "GET",
                "get-users",
                "",
                localStorage.getItem("access-token"),
                {
                    page: null,
                    count: null,
                    filters: { search: value, admin_id: null }
                },
            );

            setOptions(res.data.users)
        }, 600)

    }

    useEffect(() => {
        setEmail(selected?.email_address)
    }, [selected?.id])


    return (
        <div id="add-super-user-form">

            <div id="user-details" className="row">

                <div className="col-md-4 offset-md-4">
                    <div id="ud-personal" className="ud-content">
                        <div className="row">
                            <h5>CHOOSE INDI USER</h5>
                            <AddSuperUserAutocomplete handleOptions={handleOptions} open={open} setOpen={setOpen} loading={loading} setOptions={setOpen} options={options} setSelected={setSelected} />
                            {/* <div className="udc-name col-md-12">
                                <h4>{`${selected?.last_name || "-----"}, ${selected?.first_name || "-----"}`}</h4>
                            </div>
                            <div className="udc-email col-md-12">
                                <em>{selected?.email_address || "email address"}</em>
                            </div>
                            <div className="udc-age-gen col-md-12 row">
                                <div className="col-md-6">
                                    <h5>{genders[selected?.gender] || "gender"}</h5>
                                    <span>Gender</span>
                                </div>
                                <div className="col-md-6">
                                    <h5>{`${getAge(selected?.dob) || "0"}`}</h5>
                                    <span>Age</span>
                                </div>
                            </div> */}

                            {
                                true && <>
                                    <div className="conf-action-panel col-md-12">
                                        <h5>LINK TO THERAPIST</h5>
                                        <CustomInputV2 placeholder="Email Address" required={false} value={email} name="email" onChange={(e) => {
                                            setEmail(e.target.value)
                                        }} error={""} />
                                        <CustomActionButton action={async () => {
                                            const toastID = toast.loading("Activating Therapist...");

                                            const res = await props?.ActivateTherapist({
                                                email: email,
                                                userID: selected?.id
                                            });

                                            if (res?.success) {
                                                toast.success("Therapist Activated", {
                                                    id: toastID,
                                                });
                                                reload();
                                                setShowModal(false);
                                                return true;
                                            } else {
                                                toast.error(res?.message, {
                                                    id: toastID,
                                                });

                                                return false;
                                            }

                                        }} >
                                            Activate Therapist
                                        </CustomActionButton>
                                    </div>
                                </>
                            }
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
};


const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    ActivateTherapist,
})(AddUserUser);
